import React from 'react';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import CurrencyNoteTextsEnum from '../../../../Enums/CurrencyNoteTextsEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import ThirdPartyJobPaymentsAdminItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsAdminItem';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';

export default class EditTpEvaluatorTpJobPaymentWindowDescription extends React.Component {
  static titleForCreate = 'New Payment Request';
  static titleForEdit = 'Edit Evaluator Payment';
  static itemType = ThirdPartyJobPaymentsAdminItem;
  static serviceFunction = (edited) => ThirdPartyJobPaymentsService.UpsertEvaluatorPayment(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: (item) => EditTpEvaluatorTpJobPaymentWindowDescription.getCurrency(item),
          label: 'Currency',
          tooltipText: CurrencyNoteTextsEnum.EvaluatorPaymentEdit,
          className: 'col-6',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) =>
            item.TypeText === 'Payment Request' ||
            (item.TypeText === 'Advance Payment' && item.StatusCodeLookupValue !== 1),
        },
        {
          fieldName: 'Fee',
          label: 'Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.TypeText === 'Payment Request' && item.StatusCodeLookupValue !== 1) ||
            item.TypeText === 'Advance Payment',
        },
        {
          fieldName: 'FeeAdjustment',
          label: 'Additional Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.TypeText === 'Payment Request' && item.StatusCodeLookupValue !== 1) ||
            item.TypeText === 'Advance Payment',
        },
        {
          fieldName: 'Reimbursement',
          label: 'Reimbursement',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            ['Payment Request', 'Advance Payment'].includes(item.TypeText) && item.StatusCodeLookupValue !== 1,
        },
        {
          fieldName: 'Misc',
          label: 'Misc',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.TypeText === 'Payment Request' && item.StatusCodeLookupValue !== 1) ||
            item.TypeText === 'Advance Payment',
        },
        {
          fieldName: 'Travel',
          label: 'Travel',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.TypeText === 'Payment Request' && item.StatusCodeLookupValue !== 1) ||
            item.TypeText === 'Advance Payment',
        },
        {
          fieldName: 'Gaming',
          label: 'Gaming',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.TypeText === 'Payment Request' && item.StatusCodeLookupValue !== 1) ||
            item.TypeText === 'Advance Payment',
        },
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To *',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          roleKey: 'evaluatorpayment_editassignee',
          hide: (item) => !['Payment Request', 'Advance Payment'].includes(item.TypeText),
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) =>
            ['Payment Request', 'Advance Payment'].includes(item.TypeText) && item.StatusCodeLookupValue !== 1,
        },
      ],
    },
  ];

  static getCurrency(item) {
    return `${item.EvaluatorCurrencyCode} (${item.EvaluatorCurrencySymbol})`;
  }
}
